/** Normalize user-entered links (e.g. www.example.com) to absolute external URLs. */
export function normalizeExternalUrl(href: string): string {
  const raw = (href || '').trim();
  if (!raw) {
    return '';
  }

  const lowered = raw.toLowerCase();
  if (lowered === '#' || lowered === 'null' || lowered === 'undefined' || lowered === 'javascript:void(0)') {
    return '';
  }

  if (/^(https?:\/\/|mailto:|tel:)/i.test(raw)) {
    return raw;
  }

  if (raw.startsWith('//')) {
    return `https:${raw}`;
  }

  return `https://${raw.replace(/^\/+/, '')}`;
}
